import { useState, type KeyboardEvent } from 'react';

type Props = {
  value: string[];
  onChange: (tags: string[]) => void;
  /** suggerimenti opzionali (es. tag già usati altrove) */
  suggestions?: string[];
  placeholder?: string;
};

function normalize(s: string): string {
  return s.trim().toLowerCase();
}

export function TagsInput({ value, onChange, suggestions = [], placeholder }: Props) {
  const [draft, setDraft] = useState('');

  function commit() {
    const t = normalize(draft);
    if (!t) return;
    if (value.includes(t)) {
      setDraft('');
      return;
    }
    if (t.length > 50) return;
    onChange([...value, t]);
    setDraft('');
  }

  function remove(t: string) {
    onChange(value.filter((x) => x !== t));
  }

  function onKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      commit();
    } else if (e.key === 'Backspace' && draft === '' && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  }

  const filteredSuggestions = suggestions
    .filter((s) => !value.includes(s))
    .filter((s) => (draft ? s.includes(normalize(draft)) : true))
    .slice(0, 8);

  return (
    <div className="tags-input">
      <div className="tags-row">
        {value.map((t) => (
          <span key={t} className="tag-chip">
            {t}
            <button
              type="button"
              className="tag-x"
              onClick={() => remove(t)}
              aria-label={`Rimuovi ${t}`}
            >
              ×
            </button>
          </span>
        ))}
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={onKeyDown}
          onBlur={commit}
          placeholder={placeholder ?? 'aggiungi tag, premi Enter…'}
          className="tag-draft"
        />
      </div>
      {filteredSuggestions.length > 0 && draft.length > 0 && (
        <ul className="tag-suggestions">
          {filteredSuggestions.map((s) => (
            <li key={s}>
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  if (!value.includes(s)) onChange([...value, s]);
                  setDraft('');
                }}
              >
                {s}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
